export const myGithub = 'subritt';

export const myInfo = {
  firstName: 'Subritt',
  lastName: 'Burlakoti',
  address: 'Budhanilkantha, Kathmandu',
  email: 'subrittburlakoti@gmail.com'
}

export const whoAmI = [' Computer Engineer.', ' casual Developer.', ' Data Analyst.']

export const techStack = ['HTML', 'CSS', 'JavaScript', 'Java', 'C', 'C++', 'SQL', 'Git', 'Google Script', 'Google Sheets', 'Google Data Studio']

export const socialMedia = [
  // { title: 'facebook', link: 'https://www.facebook.com/aakritsubedi9'},
  // { title: 'instagram', link: 'https://instagram.com/aakrit_subedi'},
  { title: 'twitter', link: 'https://twitter.com/SubrittB'},
  { title: 'github', link: 'https://github.com/subritt'},
  { title: 'linkedIn', line: 'https://www.linkedin.com/in/subritt-burlakoti-537605159/'},
  // { title: 'youtube', link: 'http://youtube.com/channel/UCQa_5vTnUERh2qAGiObqizQ'}
]
